import React, { Component } from 'react';
import PropTypes from 'prop-types';
import NameEntryModal from '../NameEntryModal';
import CloneIcon from '../../themes/svg/cloneIcon';

class DuplicateEstimateButton extends Component {
  constructor(props) {
    super(props);

    this.state = {
      modalIsOpen: false,
    };
  }

  openModal = (e) => {
    e.preventDefault();
    e.stopPropagation();
    this.setState({ modalIsOpen: true });
  };

  closeModal = () => {
    this.setState({ modalIsOpen: false });
  };

  render() {
    return (
      <div className="action">
        <div className="duplicateEstimate">
          <div className="clone-estimate" onClick={this.openModal} tabIndex="-1" role="button">
            <CloneIcon />{' '}
            <span id="duplicateEstimateButton" className="actionText link">
              Duplicate
            </span>
          </div>
          <NameEntryModal
            modalIsOpen={this.state.modalIsOpen}
            validate={this.props.validate}
            action={this.props.duplicateEstimate}
            title="Duplicate Design"
            verb="Duplicate Design"
            defaultName={this.props.defaultName}
            closeModal={this.closeModal}
          />
        </div>
      </div>
    );
  }
}

DuplicateEstimateButton.propTypes = {
  duplicateEstimate: PropTypes.func.isRequired,
  validate: PropTypes.func.isRequired,
  defaultName: PropTypes.string.isRequired,
};

export default DuplicateEstimateButton;
